import { listenCustomerStatusUpdate } from 'actions'
import { noticeError } from 'components/common/newRelicBrowser'
import { CustomerStatusUpdate } from 'components/common/types'
import { store } from 'reducers/store'

class ReactSignalR {
  public watchCustomerStatusUpdate: boolean = false
  private connection = null;
  private attemptCount = 0;

  constructor() {
    window.addEventListener('online', this.handleNetworkChange);
    window.addEventListener('offline', this.handleNetworkChange);
  }

  public connectToSocket() {
    this.connection = $.hubConnection(process.env.NEXT_PUBLIC_SIGNALR_URL);
    const notificationHub = this.connection.createHubProxy('notificationHub');

    notificationHub.on('CustomerStatusUpdate', (order: CustomerStatusUpdate) => {
      store.dispatch(listenCustomerStatusUpdate(order));
    });

    this.connection.stateChanged(this.handleStateChange);
    this.startConnection();
  }

  private startConnection = () => {
    this.connection.start()
      .done(() => {
        console.log('Now connected, connection ID=' + this.connection.id);
        noticeError('SIGNALR_CONNECTION_SUCCESS', {
          errorDescription: 'Connection successfully established.'
        });
        this.attemptCount = 0; // Reset the attempt count on a successful connection
      })
      .fail(() => {
        console.error('Failed to connect. Retrying...');
        this.attemptCount++;
        setTimeout(this.startConnection, Math.min(30000, 1000 * Math.pow(2, this.attemptCount))); // Exponential backoff
      });
  }

  private handleStateChange = (state) => {
    switch (state.newState) {
      case $.signalR.connectionState.disconnected:
        noticeError('SIGNALR_CONNECTION_LOST', {
          errorDescription: 'Connection lost, attempting to reconnect...'
        });
        this.startConnection(); // Immediately try to reconnect
        break;
      case $.signalR.connectionState.connected:
        console.log('Connection established, ID=' + this.connection.id);
        break;
      case $.signalR.connectionState.connecting:
        console.log('Attempting to connect...');
        break;
      case $.signalR.connectionState.reconnecting:
        console.log('Reconnecting...');
        break;
    }
  }

  private handleNetworkChange = () => {
    if (navigator.onLine) {
      console.log('Network status: online');
      if (!this.connection || this.connection.state === $.signalR.connectionState.disconnected) {
        this.startConnection();
      }
    } else {
      console.log('Network status: offline');
    }
  }
}

export default new ReactSignalR();
